<template>
  <div v-if="store.isImpersonation" id="impersonation-banner">
    <div class="impersonation-text-container">
      <KIcon icon="fa-duotone fa-solid fa-user-secret" class="impersonation-icon" size="lg" />
      <div class="impersonation-text">
        You are impersonating <strong>{{ store.user?.email }} ({{ store.user?.id }})</strong>
      </div>
    </div>
    <BaseIconButton
      id="stop-impersonating-button"
      label="Stop Impersonating"
      icon="fa-solid fa-octagon-exclamation"
      secondary
      @click="stopImpersonate"
    />
  </div>
</template>

<script setup lang="ts">
import BaseIconButton from "@/components/base/BaseIconButton.vue";
import { KIcon } from "@k2united/frontend_components";
import { useUserStore } from "@/stores/user";
import { useImpersonate } from "@/composables/useImpersonate";

const store = useUserStore();
const { stopImpersonate } = useImpersonate();
</script>

<style scoped lang="scss">
#impersonation-banner {
  background-color: $color-background-impersonation;
  color: $color-text-inverse;
  padding: 0.25rem 0.5rem;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  @include desktop {
    display: flex;
  }
  .impersonation-text-container {
    @include body-x-small;
    display: flex;
    padding: 0.5rem 0;
    .impersonation-text {
      display: inline-block;
      text-wrap: balance;
    }
  }
  .impersonation-icon {
    margin-right: 0.5rem;
  }
  #stop-impersonating-button {
    @include desktop {
      margin-left: auto;
      margin-top: 0.125rem;
    }
  }
}
</style>
